import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Fab } from '@mui/material';

export default function WhatsAppButton({ phoneNumber }) {
    const url = `https://wa.me/${phoneNumber}`

    return (
        <Fab
            component='a'
            href={url}
            target='_blank'
            rel='noopener noreferrer'
            sx={{
                position: 'fixed',
                bottom: 24,
                right: 24,
                backgroundColor: '#25D366',
                color: '#fff',
                zIndex: 9999,
                '&:hover': {
                    backgroundColor: '#1ebe57',
                },
            }}
        >
            <WhatsAppIcon />
        </Fab>
    )
}